module.exports = __webpack_public_path__ + "static/media/nature.4cb6a371.jpg";